var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.2,
    height: 25.9,
    viewBox: "0 0 109.2 25.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_App",
    "data-name": "Google App",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(-0.3 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M10.5,12.4.4,23h0A2.672,2.672,0,0,0,3,25a2.3,2.3,0,0,0,1.4-.4h0l11.3-6.5Z",
    fill: "#d65532"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M20.6,10.5h0L15.7,7.7l-5.5,4.9,5.5,5.5,4.9-2.8A2.693,2.693,0,0,0,22,12.9,2.515,2.515,0,0,0,20.6,10.5Z",
    fill: "#ffcb31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M.4,2.8c0,.2-.1.4-.1.7V22.3a1.7,1.7,0,0,0,.1.7L10.8,12.6Z",
    fill: "#0074bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M10.5,12.9l5.2-5.2L4.4,1.2A2.116,2.116,0,0,0,3,.8a2.7,2.7,0,0,0-2.6,2h0Z",
    fill: "#00a076"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626",
    transform: "translate(-0.3 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M35.7,3.7A2.489,2.489,0,0,1,35,5.6a2.52,2.52,0,0,1-2.1.8,3.227,3.227,0,0,1-2.1-.8,2.9,2.9,0,0,1,0-4.2A2.878,2.878,0,0,1,32.9.5a5.019,5.019,0,0,1,1.2.2,3.49,3.49,0,0,1,.9.6l-.5.5a2.175,2.175,0,0,0-1.6-.7,2.035,2.035,0,0,0-1.5.6,2.36,2.36,0,0,0-.7,1.6,1.99,1.99,0,0,0,.7,1.6,2.2,2.2,0,0,0,1.5.6,2.271,2.271,0,0,0,1.6-.6A2.22,2.22,0,0,0,35,3.8H32.9V3.3h2.7A.6.6,0,0,1,35.7,3.7Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M40,1.3H37.4V3.1h2.3v.7H37.4V5.6H40v.7H36.7V.6H40Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M43.1,6.3h-.7v-5H40.8V.6h3.9v.7H43.1v5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M47.5,6.3V.6h.7V6.3h-.7Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M51.4,6.3h-.7v-5H49.1V.6H53v.7H51.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M60.4,5.6a2.723,2.723,0,0,1-2.1.9,2.878,2.878,0,0,1-2.1-.9,2.782,2.782,0,0,1-.8-2.1,3.227,3.227,0,0,1,.8-2.1A2.723,2.723,0,0,1,58.3.5a2.878,2.878,0,0,1,2.1.9,2.782,2.782,0,0,1,.8,2.1A3.227,3.227,0,0,1,60.4,5.6Zm-3.6-.5a2.175,2.175,0,0,0,3,0,2.271,2.271,0,0,0,.6-1.6,2.271,2.271,0,0,0-.6-1.6,2.175,2.175,0,0,0-3,0,2.271,2.271,0,0,0-.6,1.6A2.271,2.271,0,0,0,56.8,5.1Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M62.2,6.3V.6h.9L65.9,5h0V.6h.7V6.3h-.8L63,1.7h0V6.3Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M55.2,14.6a4,4,0,1,0,4,4A3.889,3.889,0,0,0,55.2,14.6Zm0,6.4A2.27,2.27,0,0,1,53,18.6a2.288,2.288,0,0,1,2.3-2.4,2.349,2.349,0,0,1,2.3,2.4A2.5,2.5,0,0,1,55.2,21Zm-8.8-6.4a4,4,0,1,0,4,4A3.833,3.833,0,0,0,46.4,14.6Zm0,6.4a2.349,2.349,0,0,1-2.3-2.4,2.288,2.288,0,0,1,2.3-2.4,2.349,2.349,0,0,1,2.3,2.4A2.288,2.288,0,0,1,46.4,21ZM36,15.8v1.7h4.1a2.95,2.95,0,0,1-.9,2.1,4.078,4.078,0,0,1-3.1,1.2,4.5,4.5,0,1,1,0-9A4.381,4.381,0,0,1,39.2,13l1.2-1.2a5.859,5.859,0,0,0-4.3-1.7,6.318,6.318,0,0,0-6.3,6.2,6.318,6.318,0,0,0,6.3,6.2,5.494,5.494,0,0,0,4.3-1.7,5.729,5.729,0,0,0,1.5-4,3.75,3.75,0,0,0-.1-1.1H36Zm42.7,1.3a3.688,3.688,0,0,0-7.2,1.4,3.889,3.889,0,0,0,4,4,3.8,3.8,0,0,0,3.3-1.8l-1.4-.9a2.305,2.305,0,0,1-2,1.1,1.961,1.961,0,0,1-1.9-1.2l5.4-2.2Zm-5.4,1.4a2.157,2.157,0,0,1,2.1-2.3,1.464,1.464,0,0,1,1.5.9Zm-4.4,3.8h1.8V10.5H68.9ZM66,15.5h0a2.991,2.991,0,0,0-2.2-.9,3.976,3.976,0,0,0-3.8,4,3.909,3.909,0,0,0,3.8,4,2.6,2.6,0,0,0,2.1-.9H66v.6c0,1.5-.8,2.4-2.1,2.4a2.253,2.253,0,0,1-2-1.4l-1.5.6A3.755,3.755,0,0,0,64,26.3c2.1,0,3.8-1.2,3.8-4.2V14.9H66ZM64,21a2.27,2.27,0,0,1-2.2-2.4A2.27,2.27,0,0,1,64,16.2a2.195,2.195,0,0,1,2.1,2.4A2.195,2.195,0,0,1,64,21ZM87,10.5H82.8V22.3h1.8V17.8H87a3.734,3.734,0,0,0,3.9-3.7A3.653,3.653,0,0,0,87,10.5Zm.1,5.7H84.6v-4h2.5a2.092,2.092,0,0,1,2.1,2A2.167,2.167,0,0,1,87.1,16.2Zm10.8-1.7a3.245,3.245,0,0,0-3.1,1.8l1.6.7a1.624,1.624,0,0,1,1.6-.9,1.765,1.765,0,0,1,1.9,1.5v.1a3.522,3.522,0,0,0-1.8-.5c-1.7,0-3.4.9-3.4,2.7a2.717,2.717,0,0,0,2.9,2.6,2.264,2.264,0,0,0,2.2-1.2h.1v.9h1.7V17.7C101.5,15.7,100,14.5,97.9,14.5ZM97.7,21c-.6,0-1.4-.3-1.4-1,0-.9,1-1.3,1.9-1.3a3.408,3.408,0,0,1,1.6.4A2.149,2.149,0,0,1,97.7,21Zm10-6.2-2,5.1h-.1l-2.1-5.1h-1.9l3.1,7.2-1.8,4h1.8l4.8-11.1h-1.8ZM91.8,22.3h1.8V10.5H91.8Z",
    transform: "translate(-0.3 -0.5)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.dafa4ecd2fea4caceb7d2953d325d1af.svg";
export { ForwardRef as ReactComponent };